import type { FeaturedItemsStoryblok } from "@/component-types-sb";
import { Card } from "@/components/layout/Card";
import { BodyText, Divider, H2 } from "@/components/typography";
import { storyblokEditable } from "@storyblok/react/rsc";

type FeaturedItemsPops = {
  blok: FeaturedItemsStoryblok;
};

const FeaturedItems = ({ blok }: FeaturedItemsPops) => (
  <section
    className="py-8 mx-2 lg:mx-4 text-center"
    {...storyblokEditable(blok)}
  >
    <H2 colorScheme="primary">{blok.headline}</H2>
    <BodyText className="max-w-2xl mx-auto mt-4 text-center">
      {blok.text}
    </BodyText>

    <Divider />

    <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
      {blok.items?.map((nestedBlok: any, index) => (
        <Card
          key={nestedBlok.id}
          size={index === 0 ? "large" : "normal"}
          image={nestedBlok.content?.image || nestedBlok.content?.images?.[0]}
          href={nestedBlok.full_slug}
          name={nestedBlok.name}
          buttonLabel="Entdecken"
        />
      ))}
    </div>
  </section>
);

FeaturedItems.blockName = "featured_items";

export default FeaturedItems;
